import $ from 'jquery'

let mountedRoot
let cleanup

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.dataset.turbolinksEval = 'false'
    script.onload = resolve
    script.onerror = () => { script.remove(); reject(new Error('Chart assets could not load')) }
    document.head.appendChild(script)
  })
}

function highchartsReady() {
  if (!window.__adminHighchartsReady) {
    const core = window.Highcharts ? Promise.resolve() : loadScript('https://code.highcharts.com/highcharts.js')
    // Keep the existing export, label, accessibility and theme features. Load
    // dependencies in order, once per session, without blocking HTML parsing.
    window.__adminHighchartsReady = [
      'modules/series-label.js', 'modules/exporting.js', 'modules/export-data.js',
      'modules/accessibility.js', 'themes/adaptive.js'
    ].reduce((ready, path) => ready.then(() => loadScript(`https://code.highcharts.com/${path}`)), core)
      .catch(error => { window.__adminHighchartsReady = null; throw error })
  }
  return window.__adminHighchartsReady
}

function initializeAdminDashboard() {
  const root = document.getElementById('admin-dashboard')
  if (root === mountedRoot) return
  if (cleanup) cleanup()
  if (!root) return
  mountedRoot = root
  const form = root.querySelector('#admin-dashboard-filter-form')
  const results = root.querySelector('#admin-dashboard-deals-table')
  const pagination = root.querySelector('#admin-dashboard-pagination')
  const status = root.querySelector('#admin-dashboard-table-status')
  const $root = $(root)
  const $date = $root.find('.daterange')
  const $country = $root.find('.admin-countries')
  let active = true
  let timer
  let request
  let version = 0
  let chart

  const setBusy = busy => {
    if (busy) results.setAttribute('aria-busy', 'true')
    else results.removeAttribute('aria-busy')
    status.textContent = busy ? root.dataset.loadingText : ''
  }
  const cancelRequest = () => {
    version += 1
    if (request) request.abort()
    request = null
    setBusy(false)
  }
  const initializeTable = () => {
    const table = results.querySelector('.admin-datatable')
    if (!table) return
    window.CarrylugDataTables.ready().then(() => {
      if (!active || !table.isConnected || $.fn.DataTable.isDataTable(table)) return
      $(table).DataTable({
        rowReorder: true, searching: false, paging: false, order: [[1, 'desc']],
        language: {emptyTable: root.dataset.emptyTable}
      })
    }).catch(() => { /* The rendered HTML table remains usable without the plugin. */ })
  }
  const tableUrl = page => {
    const url = new URL(form.action, window.location.href)
    new FormData(form).forEach((value, key) => url.searchParams.set(key, value))
    if (page) url.searchParams.set('recent_deals_page', page)
    else url.searchParams.delete('recent_deals_page')
    return url
  }
  const fetchTable = url => {
    clearTimeout(timer)
    cancelRequest()
    const current = version
    request = new AbortController()
    setBusy(true)
    fetch(url, {credentials: 'same-origin', signal: request.signal, headers: {Accept: 'application/json'}})
      .then(response => { if (!response.ok) throw new Error('Request failed'); return response.json() })
      .then(data => {
        if (!active || current !== version) return
        const table = results.querySelector('.admin-datatable')
        if (table && $.fn.DataTable && $.fn.DataTable.isDataTable(table)) $(table).DataTable().destroy()
        results.innerHTML = data.table
        pagination.innerHTML = data.pagination
        initializeTable()
      })
      .catch(error => {
        if (active && current === version && error.name !== 'AbortError') {
          status.textContent = root.dataset.errorText
        }
      })
      .finally(() => {
        if (!active || current !== version) return
        results.removeAttribute('aria-busy')
        if (status.textContent === root.dataset.loadingText) status.textContent = ''
        request = null
      })
  }
  $root.on('submit.adminDashboard', '#admin-dashboard-filter-form', event => {
    event.preventDefault()
    fetchTable(tableUrl())
  })
  $root.on('input.adminDashboard', '#admin-dashboard-filter-form input[name="query"]', function() {
    clearTimeout(timer)
    cancelRequest()
    if (this.value.length === 1) return
    timer = setTimeout(() => fetchTable(tableUrl()), 300)
  })
  $root.on('change.adminDashboard', '#admin-dashboard-filter-form select', () => fetchTable(tableUrl()))
  const paginate = event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
    const link = event.target.closest('#admin-dashboard-pagination a[href]')
    if (!link || link.closest('.disabled, .active') || link.getAttribute('href') === '#') return
    event.preventDefault()
    // Handle pagination before Rails UJS can execute an older script response.
    event.stopPropagation()
    fetchTable(tableUrl(new URL(link.href).searchParams.get('recent_deals_page')))
  }
  root.addEventListener('click', paginate, true)

  if ($.fn.daterangepicker) {
    $date.daterangepicker({autoUpdateInput: false, locale: {cancelLabel: 'Clear', format: 'DD/MM/YYYY'}})
    $date.on('apply.daterangepicker.adminDashboard', function(event, picker) {
      $(this).val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`)
      fetchTable(tableUrl())
    }).on('cancel.daterangepicker.adminDashboard', function() {
      $(this).val('')
      fetchTable(tableUrl())
    })
  }
  if ($.fn.select2) {
    $country.select2({
      placeholder: $country.data('placeholder'), allowClear: true, width: 'resolve',
      ajax: {
        url: $country.data('options-url'), dataType: 'json', delay: 250,
        data: params => ({q: params.term || '', page: params.page || 1}),
        processResults: data => data
      }
    })
  }
  initializeTable()
  const chartElement = root.querySelector('#demo-highchart')
  highchartsReady().then(() => {
    if (!active || !chartElement.isConnected) return
    chart = window.Highcharts.chart(chartElement, {
      chart: {type: 'spline', backgroundColor: '#ffffff', height: 170, spacing: [10, 8, 15, 10]},
      title: {text: ''},
      xAxis: {categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']},
      yAxis: {title: {text: ''}, tickInterval: 20, min: 0},
      plotOptions: {line: {dataLabels: {enabled: true}, enableMouseTracking: true}},
      credits: {enabled: false},
      series: [
        {name: 'New Users', data: JSON.parse(chartElement.dataset.monthlyNew)},
        {name: 'Existing Users', data: JSON.parse(chartElement.dataset.monthlyExisting)}
      ]
    })
    chartElement.removeAttribute('aria-busy')
  }).catch(() => {
    if (!active) return
    chartElement.removeAttribute('aria-busy')
    chartElement.textContent = 'Chart could not load. Please refresh to retry.'
  })

  cleanup = () => {
    active = false
    clearTimeout(timer)
    cancelRequest()
    $root.off('.adminDashboard')
    root.removeEventListener('click', paginate, true)
    $date.off('.adminDashboard')
    const picker = $date.data('daterangepicker')
    if (picker) picker.remove()
    if ($country.hasClass('select2-hidden-accessible')) $country.select2('destroy')
    if (chart) chart.destroy()
    mountedRoot = null
    cleanup = null
  }
}

$(initializeAdminDashboard)
document.addEventListener('turbolinks:load', initializeAdminDashboard)
document.addEventListener('turbolinks:before-cache', () => { if (cleanup) cleanup() })
